type FeatureFlagKeys = keyof typeof fallbackFeatureFlags;

const fallbackFeatureFlags = {
  "fwa-340-document-template": true,
  "fwa-353-lenders-in-unsecured-business-loan": true,
  "error-response-api-flag": true,
  "fwa-463-glasses-nvic": true,
  "li-273-broker-loop": false,
  "fwa-485-application-layout": false,
  "fwa-544-status-page": false,
  "fwa-510-asset-insurance": false,
  "fwa-571-loan-details-commission": false,
  "fwa-606-demo-commercial-application": false,
  "fwa-613-fui-sidebar-nav": false,
  "li-441-quotes-uplift": false,
  "fwa-757-fin-chat-agent": false,
};

export { fallbackFeatureFlags };
export type { FeatureFlagKeys };
